import { render, staticRenderFns } from "./commonProblem.vue?vue&type=template&id=45c56132&scoped=true&"
import script from "./commonProblem.vue?vue&type=script&lang=js&"
export * from "./commonProblem.vue?vue&type=script&lang=js&"
import style0 from "./commonProblem.vue?vue&type=style&index=0&id=45c56132&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c56132",
  null
  
)

export default component.exports